import React, { useEffect, useState } from 'react'
import TravelImg from '../../assets/travel.png'
import Slider from "react-slick";
import { LiaAngleRightSolid, LiaAngleLeftSolid } from "react-icons/lia";
import ProductCard from '../../components/productCard';
import { useGetAuthUserQuery, useGetCountSavedListQuery, useLazyGetSavedPackingListQuery, usePartialPackingQuery, usePerfectPackingQuery, usePrimaryBadgesQuery } from '../../services/Api';
import { BASE_URL_IMAGE } from '../../services/ApiEndpoints';
import { Edit2, Edit2Icon } from 'lucide-react';
import EditProfiles from '../adminPanel/pages/editProfiles';
import CurvedImg from '../../components/curvedImg';
import TravelCard from '../../components/travelCard';
import BgImage from '../../assets/bg_image.webp'
import { primary_badge } from '../../assets/updated_assests/assets';
import CardGridSkelton from '../../components/skelton/cardSkelton';
const TravellerProfile = () => {
    const { data, isLoading } = useGetAuthUserQuery()
    const { data: count, isLoading: countLoading } = useGetCountSavedListQuery();
    const { data: partialData, isLoading: partialLoading } = usePartialPackingQuery();
    const { data: perfectData, isLoading: perfectLoading } = usePerfectPackingQuery();
    const { data: primaryBadges } = usePrimaryBadgesQuery();
    console.log("data in data", partialData, perfectData)
    const [trigger, { data: savedPacking, isLoading: loading }] = useLazyGetSavedPackingListQuery();
    const [showEditProfile, setShowEditProfile] = useState(false);
    const [activeTab, setActiveTab] = useState("products");
    useEffect(() => {
        trigger();
    }, [])
    const CustomNextArrow = ({ onClick }) => (
        <div
            className="absolute -right-[40px] top-1/2 transform -translate-y-1/2 bg-transparent text-bgprimary p-2 rounded-full cursor-pointer "
            onClick={onClick}
        >
            <LiaAngleRightSolid />
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div
            className="absolute -left-[40px] top-1/2 transform -translate-y-1/2 bg-transparent text-bgprimary p-2 rounded-full cursor-pointer  z-10"
            onClick={onClick}
        >
            <LiaAngleLeftSolid />
        </div>
    );
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };

    const step = 1000;
    const badgePoints = data?.badgePoints || 0;
    const maxBadgePoints = Math.ceil(badgePoints / step) * step || step;
    const badgePercent = Math.min((badgePoints / maxBadgePoints) * 100, 100);
    const badgeImagePrimary = Array.isArray(primaryBadges?.data) && primaryBadges?.data?.length > 0 && data?.badgePoints
        ? [...primaryBadges?.data]
            .sort((a, b) => a.points - b.points)
            .reverse()
            .find(badge => data.badgePoints >= badge.points)?.badgeImage
        : null;
    return (
        <div>
            <div className="h-[350px] " style={{ backgroundImage: `url(${data?.backgroundImage ? `${BASE_URL_IMAGE}${data?.backgroundImage}` : BgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}  >
                <div className="max-w-[1050px] grid md:grid-cols-2 grid-cols-1 gap-4 px-4 mx-auto relative h-full">
                    <div className={`rounded-[20px] bg-bgprimary p-5 max-w-md h-fit self-end mb-5`}>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center justify-start gap-4 mb-2">
                                <div className="border-2 w-12 h-12 border-bgprimary rounded-full">
                                    <img
                                        src={data?.profilePicture ? `${BASE_URL_IMAGE}${data?.profilePicture}` : TravelImg}
                                        alt="Profile"
                                        className="w-full h-full rounded-full object-cover"
                                    />
                                </div>
                                <div className="">
                                    <h2 className='text-dark font-quicksand font-bold  text-[20px] tracking-[6%]' >
                                        {data?.firstName} {data?.lastName}
                                    </h2>
                                    <h2 className='text-dark font-quicksand font-bold  text-[16px] tracking-[6%]' >
                                        {data?.nationality}
                                    </h2>
                                </div>
                            </div>
                        </div>


                        <div className="ml-2 w-full text-left">

                            <p className={`text-[13px] break-all text-left font-quicksand font-noraml  text-dark}`}>
                                {data?.description}
                            </p>


                        </div>
                    </div>
                    <button onClick={() => setShowEditProfile(!showEditProfile)} className=" flex items-center gap-2 border-2 border-dark px-5 py-3  h-fit w-fit font-quicksand text-dark font-bold text-[16px] bg-white md:absolute bottom-4 right-0">
                        <Edit2 />  {showEditProfile ? 'Show' : 'Edit'} Profile
                    </button>
                </div>




            </div>
            {showEditProfile ?
                <div className=" py-6">
                    <EditProfiles />
                </div>
                :
                <div className="max-w-[1050px] mx-auto px-4 py-10 ">
                    <div className="grid md:grid-cols-1 grid-cols-1 gap-4 ">

                        <div className="content_div z-10">
                            <div className="flex items-center gap-2">
                                {badgeImagePrimary ?
                                    <div className="">
                                        <img src={`${BASE_URL_IMAGE}${badgeImagePrimary}`} className="w-[145px] h-[120px]" />
                                    </div>
                                    :
                                    <div className="w-[145px] h-[120px] flex justify-center items-center bg-bgprimary">
                                        <span className="text-dark font-quicksand font-bold text-[16px] tracking-[6%]" >No Badge</span>
                                    </div>
                                }

                                <div className="w-full">
                                    <p className='text-dark font-roboto-mono italic font-bold flex items-center gap-1 text-base  my-2' >
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.5 15.5L15 12C15.1833 11.8167 15.3292 11.6 15.4375 11.35C15.5458 11.1 15.6 10.8333 15.6 10.55C15.6 9.98333 15.4 9.5 15 9.1C14.6 8.7 14.1167 8.5 13.55 8.5C13.2333 8.5 12.9208 8.59167 12.6125 8.775C12.3042 8.95833 11.9333 9.26667 11.5 9.7C11 9.23333 10.6083 8.91667 10.325 8.75C10.0417 8.58333 9.75 8.5 9.45 8.5C8.88333 8.5 8.4 8.7 8 9.1C7.6 9.5 7.4 9.98333 7.4 10.55C7.4 10.8333 7.45417 11.1 7.5625 11.35C7.67083 11.6 7.81667 11.8167 8 12L11.5 15.5ZM19.9 12.25L12.75 19.4C12.55 19.6 12.325 19.75 12.075 19.85C11.825 19.95 11.575 20 11.325 20C11.075 20 10.825 19.95 10.575 19.85C10.325 19.75 10.1 19.6 9.9 19.4L1.075 10.575C0.891667 10.3917 0.75 10.1792 0.65 9.9375C0.55 9.69583 0.5 9.44167 0.5 9.175V2C0.5 1.45 0.695833 0.979167 1.0875 0.5875C1.47917 0.195833 1.95 0 2.5 0H9.675C9.94167 0 10.2 0.0541667 10.45 0.1625C10.7 0.270833 10.9167 0.416667 11.1 0.6L19.9 9.425C20.1 9.625 20.2458 9.85 20.3375 10.1C20.4292 10.35 20.475 10.6 20.475 10.85C20.475 11.1 20.4292 11.3458 20.3375 11.5875C20.2458 11.8292 20.1 12.05 19.9 12.25ZM11.325 18L18.475 10.85L9.65 2H2.5V9.15L11.325 18ZM5 6C5.41667 6 5.77083 5.85417 6.0625 5.5625C6.35417 5.27083 6.5 4.91667 6.5 4.5C6.5 4.08333 6.35417 3.72917 6.0625 3.4375C5.77083 3.14583 5.41667 3 5 3C4.58333 3 4.22917 3.14583 3.9375 3.4375C3.64583 3.72917 3.5 4.08333 3.5 4.5C3.5 4.91667 3.64583 5.27083 3.9375 5.5625C4.22917 5.85417 4.58333 6 5 6Z" fill="#25231B" />
                                        </svg>
                                        {data?.badgePoints || 0} westbreeze points
                                    </p>
                                    <div className="bg-bgprimary rounded-md p-6 mb-5">
                                        <div className=" bg-white rounded-[10px] w-full h-[3rem]">
                                            <div className=" bg-[#ECE8CE] rounded-[10px]  h-[3rem]" style={{ width: `${badgePercent}%` }} ></div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <p className='text-dark font-roboto-mono italic font-bold flex items-center gap-1 text-base  my-2' >
                                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.1 21.5L6.2 18.3L2.6 17.5L2.95 13.8L0.5 11L2.95 8.2L2.6 4.5L6.2 3.7L8.1 0.5L11.5 1.95L14.9 0.5L16.8 3.7L20.4 4.5L20.05 8.2L22.5 11L20.05 13.8L20.4 17.5L16.8 18.3L14.9 21.5L11.5 20.05L8.1 21.5ZM8.95 18.95L11.5 17.85L14.1 18.95L15.5 16.55L18.25 15.9L18 13.1L19.85 11L18 8.85L18.25 6.05L15.5 5.45L14.05 3.05L11.5 4.15L8.9 3.05L7.5 5.45L4.75 6.05L5 8.85L3.15 11L5 13.1L4.75 15.95L7.5 16.55L8.95 18.95ZM10.45 14.55L16.1 8.9L14.7 7.45L10.45 11.7L8.3 9.6L6.9 11L10.45 14.55Z" fill="#25231B" />
                                </svg>

                                Special Badges
                            </p>
                            <div className="border-[6px] border-bgprimary rounded-[20px] p-6 mb-5">
                                {data?.badges?.special?.length > 0 ?
                                    <>
                                        <div className="flex flex-wrap items-center gap-2">
                                            {data?.badges?.special.map((item, id) => {
                                                return (
                                                    <img key={id} src={`${BASE_URL_IMAGE}${item.badgeImage}`} className="w-[72px] h-[72px] bg-white rounded-md" />
                                                )
                                            })}
                                        </div>
                                    </>
                                    :
                                    <div className="flex justify-center items-center">
                                        <span className="text-dark font-quicksand font-bold text-[16px] tracking-[6%]" >No Special Badge</span>
                                    </div>
                                }

                            </div>
                        </div>

                    </div>

                    <div className="my-10">
                        <h2 className='font-roboto-mono capitalize text-center font-bold italic text-4xl mb-5' >my packing lists</h2>
                        <p className={`text-[13px] text-center font-quicksand font-noraml mb-6  text-dark}`}>
                            Your saved packing lists will appear here
                        </p>
                        {savedPacking?.data?.length > 0 ?
                            <>
                                <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
                                    {savedPacking?.data?.map((item) => {
                                        return (
                                            <TravelCard item={item} />
                                        )
                                    })}
                                </div>
                            </>
                            :
                            <>
                                <CardGridSkelton />
                            </>
                        }

                    </div>

                    {/* <div className="flex gap-2 mb-4 mt-8">
                        <button
                            onClick={() => setActiveTab("products")}
                            className={`px-5 py-3 font-roboto-mono font-bold italic rounded-none ${activeTab === "products"
                                ? "bg-orange text-dark"
                                : "bg-bgprimary text-dark"
                                }`}
                        >
                            My Products
                        </button>
                        <button
                            onClick={() => setActiveTab("packingLists")}
                            className={`px-5 py-3 font-roboto-mono font-bold italic rounded-none ${activeTab === "packingLists"
                                ? "bg-orange text-dark"
                                : "bg-bgprimary text-dark"
                                }`}
                        >
                            My Packing Lists
                        </button>
                    </div>
                  
                    {activeTab === "products" ? <>
                        <div className="my-5">
                            <h2 className='font-bold font-roboto-mono text-[40px] text-dark italic' >My products</h2>
                            
                            <h2>Products Not Found</h2>
                        </div>
                    </> :
                        <>
                            <div className="my-5">
                                <h2 className='font-bold font-roboto-mono text-[40px] text-dark italic' >My packing lists</h2>
                                <div className="my-4 grid md:grid-cols-6 grid-cols-2 gap-4">
                                    {savedPacking?.data.map((item) => {
                                        return (
                                            <div className='bg-bgprimary rounded-md p-2 overflow-hidden' key={item?._id} >
                                                <div className="relative w-full overflow-hidden">
                                                    <img src={`${BASE_URL_IMAGE}${item?.thumbnail}`} className='w-full h-[180px] object-cover  ' alt="" />
                                                    <div className="absolute bottom-5 left-0 w-full h-[10px] bg-transparent">
                                                        <div className={`absolute bottom-0 left-[50%] inset-0 w-full h-full bg-transparent after:content-[''] after:block after:w-[170px] after:h-[100px] after:bg-bgprimary  after:rounded-[100%] after:scale-x-[2] after:translate-x-[-50%] after:opacity-100`}></div>
                                                    </div>

                                                </div>
                                               

                                                <p className='text-dark font-quicksand font-medium text-[12px] line-clamp-2' > {item?.description}</p>
                                            </div>
                                        )
                                    })}
                                    {savedPacking?.data.length == 0 && (
                                        <h2 className='py-3' >No Saved Packing List</h2>
                                    )}

                                </div>
                            </div>
                        </>} */}


                </div>
            }


            {/* <EditProfiles /> */}

        </div>
    )
}

export default TravellerProfile
